export default "__VITE_ASSET__CP$PSaxL__"